module.exports = __webpack_public_path__ + "static/media/ship_lime_flip.4c88e38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_lime_flip.png
// module id = 213
// module chunks = 0